import React from 'react';
import ReSelect from 'react-select';
import {useTranslation} from 'react-i18next';
import {Option} from './MultiSelect';

interface SingleSelectProps {
    options: Option[];
    value?: Option | null;
    onChange: (option: Option | null) => void;
    disabled?: boolean;
    isClearable?: boolean;
    placeholder?: string;
    menuPlacement?: 'auto' | 'top' | 'bottom';
}

SingleSelect.defaultProps = {
    value: undefined,
    disabled: false,
    placeholder: undefined,
    menuPlacement: 'auto',
};

export function SingleSelect(props: SingleSelectProps): JSX.Element {
    const {options, value, onChange, disabled, isClearable, placeholder, menuPlacement} = props;
    const {t} = useTranslation();

    return (
        <ReSelect<Option, false>
            isDisabled={disabled}
            isClearable={isClearable}
            placeholder={placeholder || t('presEditPage.editSidebar.elements.selectPlaceholder')}
            options={options}
            value={value ?? null}
            onChange={onChange}
            isMulti={false}
            hideSelectedOptions={false}
            closeMenuOnSelect
            menuPlacement={menuPlacement}
            menuShouldScrollIntoView={false}
            styles={{
                indicatorSeparator: () => ({display: 'none'}),
                indicatorsContainer: (base) => ({...base, display: 'none', padding: '.5em'}),
                dropdownIndicator: (base) => ({...base, padding: '.5em'}),
                valueContainer: (base) => ({
                    ...base,
                    padding: '0.125em 2.875em 0.125em .5em',
                    flexWrap: 'nowrap',
                    outline: 'none',
                    border: 'none',
                }),
                placeholder: (base) => ({...base, margin: '0 0.125em', fontSize: '0.875em', color: '#545454'}),
                singleValue: (base) => ({...base, fontSize: '0.75em'}),
                input: (base) => ({
                    ...base,
                    padding: '0.125em 0',
                    margin: '0.125em',
                }),
                control: (base) => ({
                    ...base,
                    fontSize: 'inherit',
                    borderRadius: '0.625em',
                    borderWidth: '0.0625em',
                    minHeight: '2.375em',
                    cursor: 'pointer',
                    border: 'none',
                    backgroundColor: '#4949491A',
                }),
                option: (base, state) => {
                    let backgroundColor = 'white';
                    if (state.isSelected) {
                        backgroundColor = '#4949491A';
                    } else if (state.isFocused) {
                        backgroundColor = '#f5f5f5';
                    }

                    return {
                        ...base,
                        fontSize: '0.875em',
                        padding: '.5em .75em',
                        backgroundColor,
                        color: '#676666',
                        cursor: 'pointer',
                    };
                },
                container: (base) => ({...base, width: '100%'}),
            }}
        />
    );
}
